<template>
  <div>
    <template>
      every {{
      `${interval.amount}
      ${durationUnitLabelFor(interval.unit)} `}}
      <template v-if="interval.unit === DurationUnit.year">
        on {{ MonthToString[interval.month]+ " " + ordinalize(interval.day)}}
      </template>
      <template v-if="interval.unit === DurationUnit.month">
        on the {{ordinalize(interval.day)}}
      </template>
      <template v-if="interval.unit === DurationUnit.week">
        on {{weekdaysString}}
      </template>
      <template  v-if="interval.unit === DurationUnit.day || interval.unit === DurationUnit.week
       || interval.unit === DurationUnit.month || interval.unit === DurationUnit.year">
        at {{timeOfDayDisplay}}
      </template>
      after the first trigger
      <template v-if="interval.end_type !== IntervalEndType.Never">
        , and ends
        <template v-if="interval.end_type === IntervalEndType.SpecificDate">
          {{intervalEndDate}}
        </template>
        <template v-if="interval.end_type === IntervalEndType.NumberOfOccurrences">
          after {{interval.number_of_occurrences}} occurrences
        </template>
        <template v-if="interval.end_type === IntervalEndType.OnCondition &&  Object.keys(interval.end_condition_conditional_rule_sets).length > 0">
            <template v-for="(ruleSet, index) in interval.getSortedConditionalRuleSets('end_condition')">
              <conditional-display-rule
                :key="ruleSet.client_id"
                :class="{ 'condition-rule': true }"
                :conditional-rule-set="ruleSet"
                :totalRuleSets="Object.keys(interval.end_condition_conditional_rule_sets).length"
                hideSortControls
                :disabled="true">
              </conditional-display-rule>
              <slot name="value" :uniqueId="index" :model="ruleSet" fieldName="conditional_value"></slot>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {DurationType} from "~/enums/durationType";
  import DurationAndTimeHelper from "~/helpers/durationAndTimeHelper";
  import {statusActivationDateComparisonVOptions} from "~/helpers/statusActivationHelper";
  import {ObjectModelTriggerBasedOnType} from "~/enums/objectModelTriggerBasedOnType";
  import {AmPmToString} from "~/enums/AmPm";
  import {DurationUnit} from "~/enums/durationUnit";
  import {weekdayName, weekDays} from "~/enums/weekday";
  import {MonthToString} from "~/enums/month";
  import Interval from "~/models/interval";
  import {IntervalEndType} from "~/enums/intervalEndType";
  import DatetimeHelper from "~/helpers/datetimeHelper";
  import {DatetimeMode} from "~/models/datetimeMode";
  import ConditionalDisplayRule from "~/components/conditionalRuleBuilder/conditionalDisplayRule.vue"
  import {NumberHelper} from "~/helpers/numberHelper";

  export default Vue.extend({
    props:{
      interval:{
        required: true,
        type: Interval
      }
    },
    components: {ConditionalDisplayRule},
    computed:{
      intervalEndDate(){
        return DatetimeHelper.formatDate(
          DatetimeHelper.parseDate(this.interval.end_date),
          DatetimeHelper.timezone,
          DatetimeHelper.displayFormat(DatetimeMode.Date),
        );
      },
      timeOfDayDisplay(): string{
        let timeOfDay = this.interval.time_of_day.toString() + ":";
        if (this.interval.time_minute.toString().length === 1){
          timeOfDay += "0"
        }
        timeOfDay += this.interval.time_minute + " " + AmPmToString[this.interval.time_am_or_pm];
        return timeOfDay
      },
      weekdaysString(): string {
        const selectedDays = [];
        for (const day of this.weekDays) {
          if (this.interval.weekdays.includes(day)) selectedDays.push(this.weekdayName[day]);
        }
        return selectedDays.join(", ");
      }
    },
    methods:{
      durationUnitLabelFor(durationUnit){
        return DurationAndTimeHelper.durationUnitOptions.find(x => x.value === durationUnit).label
      },
      comparisonLabelFor(comparisonEnum){
        return statusActivationDateComparisonVOptions.find(x => x.value === comparisonEnum).label
      },
      ordinalize(num: number) {
        return NumberHelper.ordinalize(num)
      },
    },
    data: function() {
      return {
        DurationType,
        ObjectModelTriggerBasedOnType,
        AmPmToString,
        DurationUnit,
        weekdayName,
        weekDays,
        MonthToString,
        IntervalEndType
      };
    }
  });
</script>